// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { connect } from 'react-redux';
import { setTag } from '../../actions/activitiesActions';
import '../../styles/containers/Activity.css';

const onClick = (action, name, back) => {
  action(name);
  back();
};

function tag({ name, setName, back }) {
  return (
    <div
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      tabIndex='0'
      className='tag'
      role='button'
      onClick={() => onClick(setName, name, back)}
      name={name}
    >
      {name}
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    setName: data => dispatch(setTag(data)),
  };
}

export default connect(null, mapDispatchToProps)(tag);
